import React from 'react';
import { Link } from 'react-router-dom';
import { Box, Button, Typography } from '@mui/material';
import { Home, ArrowBack } from '@mui/icons-material';

const NotFoundPage = () => {
  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        minHeight: '100vh',
        textAlign: 'center',
        p: 4,
        backgroundColor: '#f5f5f5'
      }}
    >
      <Typography 
        variant="h1" 
        sx={{ 
          fontSize: { xs: '6rem', md: '10rem' }, 
          fontWeight: 900, 
          color: 'primary.main',
          lineHeight: 1,
          mb: 2
        }}
      >
        404
      </Typography>
      
      <Typography variant="h5" fontWeight={600} mb={1}>
        Página no encontrada
      </Typography>
      
      <Typography variant="body1" color="text.secondary" mb={4} maxWidth={400}>
        Lo sentimos, la página que buscas no existe o ha sido movida.
      </Typography>
      
      <Box sx={{ display: 'flex', gap: 2 }}>
        <Button 
          component={Link} 
          to="/" 
          variant="contained" 
          startIcon={<Home />}
          size="large"
        >
          Ir al inicio
        </Button>
        <Button 
          onClick={() => window.history.back()} 
          variant="outlined" 
          startIcon={<ArrowBack />}
          size="large"
        >
          Volver atrás
        </Button>
      </Box>
    </Box>
  );
};

export default NotFoundPage;